import { createSvgIcon } from "@mui/material";

const InsertColumnRight = createSvgIcon(
  // From https://remixicon.com/ (https://github.com/Remix-Design/RemixIcon)
  <path d="M10 3C10.5523 3 11 3.44772 11 4V20C11 20.5523 10.5523 21 10 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H10ZM9 5H5V19H9V5ZM18 7C20.7614 7 23 9.23858 23 12C23 14.7614 20.7614 17 18 17C15.2386 17 13 14.7614 13 12C13 9.23858 15.2386 7 18 7ZM19 9H17V10.999L15 11V13L17 12.999V15H19V12.999L21 13V11L19 10.999V9Z"></path>,
  "InsertColumnRight"
);

export default InsertColumnRight;
